import React, { memo, useState, useEffect, useCallback } from "react";
import { getCommonService } from "@/api/home";
import styles from "./style.module.less";
import Bus from "@/utils/bus";
import Empty from "../../../empty";
import { Tabs } from "antd";
import ImgComps from "../../../ImgComps";
import { HomeOssUrl as CDN_URL, HomeContext } from "@/components/Home/utils";
import { Iprops } from "../..";
const arrow = `${CDN_URL}/right.png`;
const iconHot = `${CDN_URL}/HOT.png`;
const iconNew = `${CDN_URL}/NEW.png`;
export interface serviceItem {
  iconUrl: string | null;
  applicationBaseInfoList: {
    homeUrl: string;
    deploymentType: number;
    deepLink: string | null;
    eGovHomeUrl: string | null;
    hostAppClient: number;
  }[];
  cornerMarkerType: number; // 角标类型； 1 热门应用；2 服务上新
  cornerMarkerDisplay: number;
  applicationKey: string | null;
  applicationId: string | null;
  applicationName: string;
}
export interface serviceInterface {
  contentDtoList: serviceItem[];
  settingDto?: {
    appColumn: number; // 列
    title: string; // 标题
    appRow: number; // 行
    display: number; // 1 展示；0 不展示
  };
}
const Service = ({ onAppOrLinkClick, t }: Iprops) => {
  const [tabsData, setTabsData] = useState<any[]>([]);
  const { appRuntimeEnv, authInfo } = React.useContext(HomeContext);
  const [commonService, setCommonService] = useState<serviceInterface | null>(null);
  const [current, setCurrent] = useState(0);
  const [columns, setColumns] = useState<number>(5);
  useEffect(() => {
    getCommonData();
  }, []);
  /**
   * 异步获取常用服务
   * @function
   * @returns {Promise<void>}
   */
  const getCommonData = () => {
    getCommonService().then((res: serviceInterface) => {
      if (res) {
        setCommonService(res);
        setColumns(res?.settingDto?.appColumn || 5);
        setTabsData([{ title: res?.settingDto?.title || "", id: 0 }]);
      }
    });
  };
  const moreClick = () => {
    if (!appRuntimeEnv) return;
    Bus.emit("openHomeH5", {
      pcUrl: "/jqq_h5_pages/#/consumerService"
    });
  };
  return (
    <div className={styles.service_wrapper}>
      <div className={styles.service_content}>
        <div
          className={styles.more}
          onClick={() => {
            moreClick();
          }}
        >
          <span>{t("homeIndex.all-more")}</span>
          <img src={arrow} className={styles.icon} />
        </div>
        {tabsData.length > 0 && (
          <Tabs activeKey={String(current)} className={`${styles.tab_wrap} custom_tab_ui`}>
            {tabsData.map((item: any, idx: number) => (
              <Tabs.TabPane key={idx} tab={item.title}>
                {current === 0 ? (
                  <div className={styles["tab_item_content"]}>
                    {(commonService?.contentDtoList?.length || 0) > 0 ? (
                      <div
                        className={`${styles.content_items} ${
                          columns === 4 ? styles.content_four : styles.content_five
                        }`}
                      >
                        {commonService?.contentDtoList?.map((item: serviceItem, idx: number) => (
                          <div
                            className={styles.item}
                            key={item.applicationId || idx}
                            onClick={() => {
                              onAppOrLinkClick?.({ ...item, urlType: 2 });
                            }}
                          >
                            <ImgComps className={styles.icon} src={item.iconUrl} />
                            {item.cornerMarkerDisplay && item.cornerMarkerType === 1 ? (
                              <img className={styles.icon_tag} src={iconHot} />
                            ) : null}
                            {item.cornerMarkerDisplay && item.cornerMarkerType === 2 ? (
                              <img className={styles.icon_tag1} src={iconNew} />
                            ) : null}
                            <div className={styles.title}>{item.applicationName} </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <Empty />
                    )}
                  </div>
                ) : null}
              </Tabs.TabPane>
            ))}
          </Tabs>
        )}
      </div>
    </div>
  );
};

export default Service;
